import React, { useState } from 'react'
import Container from 'components/Container'
import { getSigner } from 'utils'
import InputString from 'components/InputString'
import InputNumber from 'components/InputNumber'
import { CardBody, Button } from '@pancakeswap-libs/uikit'
import { Link as HistoryLink } from 'react-router-dom'
import { RowBetween } from 'components/Row'
import { useTranslation } from 'react-i18next'
import useToast from 'hooks/useToast'
import { BigNumber } from '@ethersproject/bignumber'
// import { useTokenContract } from '../../hooks/useContract'
// import { AutoColumn } from 'components/Column'
// import { Contract } from 'ethers'

import { Contract } from 'ethers'
import AppBody from '../AppBody'
import { Wrapper, InputTitle, InputBox, Title } from './styleds'
import { useActiveWeb3React } from '../../hooks'
import { LOCK_FACTORY } from '../../constants'
import LOCK_FACTORY_ABI from '../../constants/abis/lockFactory.json'



export default function CreateMemeProject() {
    const { account, chainId, library } = useActiveWeb3React()
    const { t } = useTranslation()

    const [name, setName] = useState('');
    const [symbol, setSymbol] = useState('');
    const [amount, setAmount] = useState(''); 
    const [loading, setLoading] = useState(false);

    const { toastSuccess, toastError } = useToast()
    
    const handleInputName = async value => {
      setName(value)
    };
    const handleInputSymbol = async value => {
      setSymbol(value)
    };

    const handleInputAmount = async value => {
      setAmount(value) 
    }
     const handleRegister = async () => {
      
      if (!chainId || !library || !account) return
       setLoading(true)
       try {
         const contract = new Contract(LOCK_FACTORY, LOCK_FACTORY_ABI,getSigner(library, account))
         const tokenAmount = BigNumber.from(amount).mul(`${10 ** Number(18)}`).toString()
         const gas = await contract.estimateGas.createMemeToken(name, symbol, tokenAmount)
         console.log(gas, '---------')
         const tx = await contract.createMemeToken(name, symbol, tokenAmount)
         // eslint-disable-next-line no-console
        //  console.log(tx, 'tx----')
        //  addTransaction(tx, {
        //   summary: `Register token ${tokenAddress}`
        // })
        await tx.wait();
        toastSuccess(t('Token created successfully'))
         setLoading(false)
       } catch (err){
        console.log(err, 'err---------')
        toastError(t('Token created failed'))
         setLoading(false)
       }
     }

    return (
      <Container>
        
        <RowBetween marginBottom='30px' maxWidth="436px">
          <span>  </span>
          <HistoryLink style={{ color:'#29CAD5' }}  to="/memelist">{ t('Create record') }</HistoryLink>
        </RowBetween>
      <AppBody>
        <Wrapper>
        <Title>
            { t('One-click create your tokens') }
          </Title>
          <CardBody>
             <InputBox>
               <InputTitle>{ t('TOKEN Name') }</InputTitle>
               <InputString value={ name } placeholder={ t('Please enter name') } onUserInput={ handleInputName }/>
             </InputBox>
             <InputBox>
               <InputTitle>{ t('TOKEN Symbol') }</InputTitle>
               <InputString value={ symbol } placeholder={ t('Please enter symbol') } onUserInput={ handleInputSymbol }/>
             </InputBox>
             <InputBox>
               <InputTitle>{ t('Issue Number') }</InputTitle>
               <InputNumber  value={ amount } placeholder={ t('Please enter the issue quantity') } onUserInput={ handleInputAmount }/>
             </InputBox>
             {/* <WarnTip>
               <span>
                <b>{t('open source code')}</b><br />
                {t('The issued token source code will be automatically verified on the block explorer')}
              </span><br />
             </WarnTip> */}

             {!name || !symbol || !amount ? (

                <Button disabled width="100%">{ t('Not all entered') }</Button>
              ) 
              : (<Button width="100%" disabled={ loading } onClick={ handleRegister }>{ loading ? `${t('Create')}...` : t('Create')}</Button>)
            }
            
          </CardBody>
        </Wrapper>
      </AppBody>
    </Container>
    )
  }